export function cpfValidator(value: string): boolean {
  if (!value) {
    return false;
  }
  if (value === "000.000.000-00") {
    return false;
  }

  const cpfValidatorRegex = /(^\d{3}\.\d{3}\.\d{3}\-\d{2}$)/;
  const isCpf = cpfValidatorRegex.exec(value);
  if (!isCpf) {
    return false;
  }
  const array = value.split("");
  const resultArray = array.filter(e => parseFloat(e).toString() === e).map(element => parseFloat(element));

  const lastDigits = resultArray.splice(-2);

  let somaDigitoUltimo = 0;
  let somaDigitoPenultimo = 0;
  for (let index = 0; index < resultArray.length; index++) {
    somaDigitoPenultimo += resultArray[index] * (10 - index);
    somaDigitoUltimo += resultArray[index] * (11 - index);
  }

  let penultimoDigito = 0;
  if (somaDigitoPenultimo % 11 >= 2) {
    penultimoDigito = 11 - (somaDigitoPenultimo % 11);
  }

  somaDigitoUltimo += penultimoDigito * 2;

  let ultimoDigito = 0;
  if (somaDigitoUltimo % 11 >= 2) {
    ultimoDigito = 11 - (somaDigitoUltimo % 11);
  }

  if (lastDigits[0] === penultimoDigito && lastDigits[1] === ultimoDigito) {
    return true;
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/util/cpfValidator.ts